import { User } from '@src/entities/User/ui/components/User';
import { Button as ButtonComponent } from '@src/shared/ui/components/Button';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { isEqual } from 'lodash';
import React, { useState } from 'react';

import { Modal } from '../Modal';

/**
 * Button: Activate
 *
 * This button is used to activate the selected version of the entity.
 *
 * @param activatedVersion
 * @param commonCriteriaVersions
 * @param currentEntity
 * @param form
 * @param refetch
 * @param setFocusedEntity
 * @returns {Element}
 * @constructor
 */
export function Button({
  activatedVersion = {},
  commonCriteriaVersions = 0,
  currentEntity = {},
  form = {},
  refetch = () => {},
  setFocusedEntity = () => {},
}) {
  const [isOpen, setIsOpen] = useState(false);

  const { isDirty, isValid } = form.formState;

  const selectedVersionValue = form?.watch('version');
  const currentFilters = form?.watch('filters');

  return (
    <ErrorHandler location="src/features/CommonCriteria/Activate/components/Button/Button.jsx">
      <User.Capability attributes={['activate']} resource="Admin:CommonCriteria">
        <ButtonComponent
          isDisabled={
            !isDirty ||
            !isValid ||
            (activatedVersion?.version === selectedVersionValue && !isDirty) ||
            (activatedVersion?.version === selectedVersionValue && !isValid) ||
            isEqual(activatedVersion?.criteria, currentFilters)
          }
          onClick={async () => {
            setIsOpen(true);
          }}
          type="submit"
          variant="solid"
        >
          Activate
        </ButtonComponent>
      </User.Capability>
      {isOpen && (
        <Modal
          activatedVersion={activatedVersion}
          commonCriteriaVersions={commonCriteriaVersions}
          currentEntity={currentEntity}
          formValues={form.getValues()}
          isOpen={isOpen}
          refetch={refetch}
          selectedVersionValue={selectedVersionValue}
          setFocusedEntity={setFocusedEntity}
          setIsOpen={setIsOpen}
        />
      )}
    </ErrorHandler>
  );
}
